<template>
  <v-container class="px-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="">{{ 'BROKER užklausų (log) žurnalas' }}</h1>
    <!-- search -->
    <broker-log-search @downloadReport="downloadReport" :loading="loading" @search="dataSearch" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.action`]="{ item }">
        <el-table-enum enumName="brockerActionTypes" :item="item.action" />
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @viewItem="viewItem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <!-- audit -->
      <modal-broker-logs
      v-model="showLog"
      :loading="loading"
      :item="modalLogItem"
    />
  </v-container>
</template>

<script>
import BrokerLogSearch from './BrokerLogSearch'
import userRole from '@/mixins/userRole'
import ModalBrokerLogs from '@/components/modals/ModalBrokerLogs'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'

export default {
  name: 'AdminData',
  components: {
    BrokerLogSearch,
    ModalBrokerLogs,
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showLog: false,
      modalLogItem: {},
      modalDeleteVardas: '',
      modalDeleteItem: null,
      listData: [],
      searchData: {},
     
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['listParams']),
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Nr'),
          align: 'start',
          value: 'id',
        },
        {
          text: this.$t('Naudotojas'),
          align: 'start',
          value: 'user_name'
        },
        {
          text: this.$t('VAR ID'),
          align: 'start',
          value: 'var_id'
        },
        {
          text: this.$t('Paslauga'),
          align: 'start',
          value: 'action',
        },
        {
          text: this.$t('Užklausos laikas'),
          align: 'start',
          value: 'created_at',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      if (!this.listData) return
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    this.setlistParams()
  },
  methods: {
    getApplicationTitle(key) {
      if (key == 'broker') {
        return 'BROKER API';
      } else if (key == 'nirvar') {
        return 'NIRVAR periodinis tikrinimas'
      }
    },
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
    },
    viewItem(item) {
      this.modalLogItem = {}
       this.$axios
        .get(`broker-logs/${item.id}`)
        .then((res) => {
          this.modalLogItem = res.data.brokerLog
          this.showLog = true
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`broker-logs/list`, data)
        .then((res) => {
          this.listData = res.data.brokerLogs ?? []
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    dataSearch(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
        .post(`broker-logs/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
